// extracted by mini-css-extract-plugin
export default {"team":"TeamSlider_team__j1hTg"};